export const TOKEN_HEADER = 'Authorization';
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_NOT_ALLOWED = 405;
export const CHROME = 'chrome';

/**********ROUTE CONSTANTS **************/
export const ROUTE_ACCOUNT_FORGOT_PASSWORD = '/account/forgot-password';
export const ROUTE_ACCOUNT_REGISTER = '/account/register';
export const ROUTE_ACCOUNT_LOGIN = '/account/login';
export const ROUTE_ACCOUNT_PROFILE = '/account/profile';
export const ROUTE_ACCOUNT_REGISTER_SUCCESS = '/account/register-success';
export const ROUTE_ACCOUNT_UNSUPPORTED_BROWSER = '/account/unsupported-browser';

export const ROUTE_ADMIN_DASHBOARD = '/user/admin-dashboard';
/*************END**************/

/**********PATTERN CONSTANTS **************/
export const EMAIL_PATTERN = '[A-Za-z0-9._%+-]{1,64}@[A-Za-z0-9\.]{1,253}$';
export const OTP_PATTERN = '^[0-9]{1,6}$';
export const YEAR_PATTERN = '^[0-9]{1,4}$';
export const NPI_PATTERN = '^[0-9]{10}$';
export const PASSWORD_MISMATCH_MESSAGE = 'Passwords are not matching.';
export const ONLY_NUMBERS_PATTERN = '^[0-9]*$';
export const LETTER_PATTERN_SPACE_HYPHEN = '^[a-zA-Z\- ]*$';
export const LETTER_WITH_SINGLE_QUOTE_PATTERN = '^[a-zA-Z\' ]*$';
export const LETTER_NUMBERS_SINGLE_QUOTE_UNDERSCORE_SPACE_PATTERN = '^[a-zA-Z0-9\'_ ]*$';
export const LETTER_NUMBERS_SINGLE_QUOTE_UNDERSCORE_PATTERN = '^[a-zA-Z0-9\'_]*$';
export const ONLY_LETTER_PATTERN = '^[a-zA-Z]+$';
export const ALPHA_NUM_PATTERN = '^[a-zA-Z0-9]*$';
export const DATE_PATTERN = '((0?[1-9]|1[012])[- /.](0?[1-9]|[12][0-9]|3[01])[- /.](19|20)?[0-9]{2})*$';
/*** END ******/

/****** CUSTOM VALIDATION MESSAGE************/
export const EMAIL_REQUIRED_MESSAGE = 'Email is required.';
export const PASSWORD_REQUIRED_MESSAGE = 'Password is required.';
export const EMAIL_PATTERN_MESSAGE = 'Enter valid email.';
export const OTP_PATTERN_MESSAGE = 'Enter 6 digit OTP.';
export const OTP_REQUIRED_MESSAGE = 'OTP is required.';
export const UNAUTHORIZED_LOGIN_MESSAGE = 'We are unable to find your email, please try to register.';
export const INCORRECT_PASSWORD_MESSAGE = 'Email or password is incorrect.';
export const USER_EXISTS_EXCEPTION_MESSAGE = 'A user with this email already exists.';
export const WRONG_PIN_ENTERED_MESSAGE = 'Wrong pin entered.';
export const PASSWORD_PATTERN_MESSAGE =
    `Password does not conform to policy minimum length 8 characters,
    should include numbers, special character, uppercase letters, lowercase letters.`;
export const CONFIRM_PASSWORD_REQUIRED_MESSAGE = 'Confirm password is required.';
export const PASSWORDS_NOT_MATCHED_MESSAGE = 'Passwords not matched.';
export const LIMIT_EXCEEDED_EXCEPTION_MESSAGE = 'OTP limit exceeded please try after sometime.';
export const PASSWORD_RESET_SUCCESSFULLY = 'Password changed successfully';
export const PASSWORD_MIN_LENGTH_MESSAGE = 'Password should be at least 8 characters.';
/************END*************/

/**** profile Personal validation messages***/
export const FIRST_NAME_REQUIRED_MESSAGE = 'First name is required.';
export const FIRST_NAME_PATTERN_MESSAGE = 'First name should only have alphabets,numbers, underscore, spaces and single quotes.';
export const FIRST_NAME_MIN_LENGTH_MESSAGE = 'First name should be at least 3 characters.';
export const FIRST_NAME_MAX_LENGTH_MESSAGE = 'First name should not be more than 30 characters.';
export const LAST_NAME_PATTERN_MESSAGE = 'Last name should only have alphabets,numbers, underscore and single quotes.';
export const LAST_NAME_MIN_LENGTH_MESSAGE = 'Last name should be at least 3 characters.';
export const LAST_NAME_MAX_LENGTH_MESSAGE = 'Last name should not be more than 30 characters.';
export const LAST_NAME_REQUIRED_MESSAGE = 'Last name is required.';
export const DOB_REQUIRED_MESSAGE = 'Date Of Birth is required.';
export const PHONE_REQUIRED_MESSAGE = 'Phone number is required.';
export const GENDER_REQUIRED_MESSAGE = 'Gender is required.';
export const DOB_PATTERN_MESSAGE = 'Enter valid date.';
export const PHONE_PATTERN_MESSAGE = 'Enter valid phone number.';
export const PROFILE_PICTURE_REQUIRED_MESSAGE = 'Profile picture is required';
export const PHONE_NUMBER_MIN_LENGTH_MESSAGE = 'Phone number should be 10 digit number.';
/********END **************/

/********Storage Key Constants */
export const WEBSITE_SOURCE = 'evidant Web';

export const USER_ID_KEY = 'USER_ID';
export const ORG_ID_KEY = 'ORG_ID';
export const REFINERY_ID_KEY = 'REFINERY_ID';
export const NODE_ID_KEY = 'NODE_ID';
export const TRANSFORM_ID_KEY = 'TRANSFORM_ID';
export const INGEST_ID_KEY = 'INGEST_ID';

export const USER_NAME_KEY = 'USER_NAME';
export const EMAIL_ID_KEY = 'EMAIL_ID';
export const USER_DATA = 'USER_DATA';
export const USER_DATA_KEY  = 'USER_DATA_KEY';
export const ORG_DATA_KEY  = 'ORG_DATA_KEY';
export const DATA_PREVIEW_NODEID_KEY = 'DATA_PREVIEW_NODEID';

export const SESSION_TIMEOUT_DATA_KEY  = 'SESSION_TIMEOUT_DATA_KEY';

export const SELECTED_REFINERY_DETAILS_KEY = 'SELECTED_REFINERY_DETAILS';
export const SELECTED_NODE_DETAILS_KEY = 'SELECTED_NODE_DETAILS_KEY';
export const SELECTED_CONFIG_JSON_KEY = 'SELECTED_CONFIG_JSON_KEY';
export const SELECTED_TRANSFORM_KEY = 'SELECTED_TRANSFORM_KEY';
export const SELECTED_DATA_TRANSFORM_CONFIG_KEY = 'SELECTED_DATA_TRANSFORM_CONFIG_VIEWMODEL_KEY';
export const SELECTED_INGESTFARM_GUID = 'SELECTED_INGESTFARM_GUID';
export const SELECTED_GRAPH_WIDTH_KEY = 'GRAPH_WIDTH';
export const SELECTED_GRAPH_HEIGHT_KEY = 'GRAPH_HEIGHT';

export const ORGANIZATIONID_ID_KEY = 'ORGANIZATIONID_ID';
export const ORGANIZATIONID_NAME_KEY = 'ORGANIZATIONID_NAME_KEY';
//Summary Persistance Keys
export const SUMMARY_SELECT_VALUE_KEY = 'SUMMARY_SELECT_VALUE_KEY';
export const SUMMARY_EMPTY_COLUMNS_KEY = 'SUMMARY_EMPTY_COLUMNS_KEY';
export const SUMMARY_FILTER_PREFS_KEY = 'SUMMARY_FILTER_PREFS_KEY';
export const SUMMARY_FILTER_KEY = 'SUMMARY_FILTER_KEY';
export const SUMMARY_SORT_KEY = 'SUMMARY_SORT_KEY';

//TEST
export const OUTPUT_DATA_KEY = 'OUTPUT_DATA_KEY';
//END
export const PARENT_DATA_NODE_KEY = 'PARENT_DATA_NODE_KEY';
export const ATTRIBUTION_NODE_KEY = 'ATTRIBUTION_NODE_KEY';
export const SELECTED_TAB_INDEX_KEY = 'SELECTED_TAB_INDEX_KEY';

export const MASTER_NODEBOXTYPES_KEY = 'MASTER_NODEBOXTYPES';
export const MASTER_TRANSFORMERS_KEY = 'MASTER_TRANSFORMERS';
export const MASTER_FARMTYPE_KEY = 'MASTER_FARMTYPE';
/*********Account Status Constants ************/

export const CONFIRMED = 'confirmed';
export const NOT_REGISTERED = 'not_registered';
export const UNCONFIRMED = 'unconfirmed';
export const UNKNOWN = 'unknown';

/*****************LOOKUP TAB CLICKED KEY************************/

export const LOOKUP_TAB_CLICKED_KEY = 'LOOKUP_TAB_CLICKED_KEY';

/************RESULTS TAB CLICKED KEY************** */

export const RESULTS_TAB_CLICKED_KEY = 'RESULTS_TAB_CLICKED_KEY';

/***********INPUT TAB CLICKED KEY************************** */

export const INPUT_TAB_CLICKED_KEY = 'INPUT_TAB_CLICKED_KEY';

/************INGEST INPUT TAB CLICKED KEY************** */

export const INGESTINPUT_TAB_CLICKED_KEY = 'INGESTINPUT_TAB_CLICKED_KEY';

/************OUTPUT TAB CLICKED KEY************** */

export const OUTPUT_TAB_CLICKED_KEY = 'OUTPUT_TAB_CLICKED_KEY';

/************RAW TAB CLICKED KEY************** */

export const RAW_TAB_CLICKED_KEY = 'RAW_TAB_CLICKED_KEY';

/**********SUMMARY TAB CLICKED KEY************ */

export const SUMMARY_TAB_CLICKED_KEY = 'SUMMARY_TAB_CLICKED_KEY';

/**********PROCESSOR INPUT SUMMARY PREVIEW CLICKED********** */

export const PROCESSR_INPUTSUMMRYPREVW_CLICKED_KEY = 'PROCESSR_INPUTSUMMRYPREVW_CLICKED_KEY';


/************APPLY FILTER BUTTON CLICKED KEY**************** */

export const APPLYFILTER_BTN_CLICKED_KEY = 'APPLYFILTER_BTN_CLICKED_KEY';

/*************TOCLEARACTIVEFILTERS_KEY************************** */

export const TOCLEARACTIVEFILTERS_KEY = 'TOCLEARACTIVEFILTERS_KEY';

/***********INPUT PREVIEW FILTER DATA KEY********************** */

export const INPUTPRVWFILTER_VM_KEY = 'INPUTPRVWFILTER_VM_KEY';

/**********RAW DATA CONNECTOR MAPPING KEY********************** */

export const RAW_DATACONNECTOR_MAPPING_KEY = 'RAW_DATACONNECTOR_MAPPING_KEY';

/**********RAW GENERAL PARAMETER KEY********************** */

export const RAW_GENERAL_PARAM_KEY = 'RAW_GENERAL_PARAM_KEY';

/*********SELECTED INGEST MAPPING GUID AND MAPPING TYPE FROM MAP LIBRARY ON CLICKING ON OK BUTTON********************* */

export const SELECTED_INGEST_MAPPING_GUID_KEY = 'SELECTED_INGEST_MAPPING_GUID_KEY';

export const SELECTED_INGEST_MAPPING_TYPE_KEY = 'SELECTED_INGEST_MAPPING_TYPE_KEY';



/********END **************/
